<style lang="scss" scoped>
$klz-red: #c50c0e;
.container {
  .row {
    margin: 10px 0;
  }
  input,
  textarea {
    width: 100%;
    padding: 5px;
    border: 1px solid #eee;
    &:focus {
      border: 1px solid $klz-red;
    }
  }
}

.profile {
  .top-section {
    display: none;
  }
  .profil-header {
    background: #f9f9f9;
    padding: 20px 0;
    h1 {
    }
    p {
      margin: 0;
      font-style: italic;
    }
  }

  .headline-data {
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 130%;
    margin-bottom: 10px;
    &:after {
      content: '';
      display: block;
      width: 7%;
      margin: 10px 0;
      height: 3px;
      background: #eee;
      @media (max-width: 768px) {
        width: 10%;
      }
    }
  }

  .data-container {
    margin-top: 40px;
    @media (max-width: 768px) {
      margin-top: 20px;
    }
  }

  .imagepreview {
    text-align: center;
    img {
      max-height: 100px;
      max-width: 100%;
      width: auto;
    }
  }
}
</style>

<template>
  <div class="profile" v-if="isLoggedIn">
    <Header />
    <!-- showDescription = Soll der Text anzeigt werden ("Hier finden sie eine Auswahl...") -->
    <Popup />
    <div class="profil-header">
      <b-container>
        <b-row>
          <b-col>
            <h1>Mein Profil</h1>
            <p>Hier können Sie Ihre Daten anpassen.</p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container class="data-container">
      <b-row>
        <b-col class="headline-data">
          Passwort
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="8" md="12">Aktuelles Passwort: </b-col>
        <b-col lg="4" md="12"><input type="password" v-model="currentpassword"/></b-col>
      </b-row>
      <b-row>
        <b-col lg="8" md="12">Neues Passwort: </b-col>
        <b-col lg="4" md="12"><input type="password" v-model="password1"/></b-col>
      </b-row>

      <b-row>
        <b-col lg="8" md="12">Neues Passwort wiederholen:</b-col>
        <b-col lg="4" md="12"><input type="password" v-model="password2"/></b-col>
      </b-row>

      <b-row class="align-items-end justify-content-center">
        <b-col class="text-right">
          <button class="btn-all" @click="setPassword">Ändern</button>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="unternehmen data-container">
      <b-row>
        <b-col lg="3" md="12">
          Filiale:
        </b-col>
        <b-col lg="9" md="12">
          <DropDown :options="unternehmensOptions" v-model="selected"></DropDown>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-lg="3" lg="9" md="12">
          <button class="btn-all" @click="createUnternehmen">Weitere Filiale anlegen</button>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="data-container" v-if="unternehmens[selected] && !unternehmen.new">
      <b-row>
        <b-col class="headline-data">
          Bilder
        </b-col>
      </b-row>
      <b-row v-if="unternehmen.logo">
        <b-col cols="12" class="imagepreview">
          <img :src="imagepath(unternehmen.logo)" alt="Logo" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Logo: </b-col>
        <b-col lg="8" md="12">
          <Upload name="logo" :id="unternehmen.id" @upload="refreshLogoImage" description="*.jpg, *.png, *.svg; max. 500kb" />
          <button class="btn-all" @click="deleteImage('logo')">Bild löschen</button>
        </b-col>
      </b-row>
      <b-row v-if="unternehmen.header" class="imagepreview">
        <b-col cols="12">
          <img :src="imagepath(unternehmen.header)" alt="Header" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Header: </b-col>
        <b-col lg="8" md="12">
          <Upload name="header" :id="unternehmen.id" @upload="refreshHeaderImage" description="*.jpg, *.png, *.svg; max. 500kb" />
          <button class="btn-all" @click="deleteImage('header')">Bild löschen</button>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="data-container" v-if="unternehmens[selected]">
      <b-row>
        <b-col class="headline-data">
          Firmen Daten
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          Name*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.firma" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Beschreibung: </b-col>
        <b-col lg="8" md="12">
          <textarea v-model="unternehmen.beschreibungprodukt"></textarea>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Branche*: </b-col>
        <b-col lg="8" md="12">
          <DropDown :options="branchen" :value="unternehmen.branche" @input="setBranche"></DropDown>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Website: </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.website" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Email: </b-col>
        <b-col lg="8" md="12">
          <input type="email" v-model="unternehmen.email" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">Telefon-Nummer: </b-col>
        <b-col lg="8" md="12"><input type="tel" v-model="unternehmen.telefon"/></b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          Straße*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.adresse" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          Hausnummer*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.nr" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          PLZ*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.plz" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          Ort*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.ort" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Bundesland*: </b-col>
        <b-col lg="8" md="12">
          <DropDown :options="bundeslaender" :value="unternehmen.bundesland" @input="setBundesland"></DropDown>
        </b-col>
      </b-row>
      <b-row v-if="bezirke.length > 0">
        <b-col lg="4" md="12"> Bezirk*: </b-col>
        <b-col lg="8" md="12">
          <DropDown :options="bezirke" :value="unternehmen.bezirk" @input="setBezirk"></DropDown>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Zahlungsarten: </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.zahlungsarten" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Liefermöglichkeiten: </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.liefermoeglichkeiten" />
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4" md="12"> Aktionen: </b-col>
        <b-col lg="8" md="12">
          <!--  <Checkbox v-model="unternehmen.ostergeschenke">Ostergeschenke / Osterdekoration</Checkbox>
          <Checkbox v-model="unternehmen.osterjause">Osterjause / Osterschmankerl</Checkbox>
           <Checkbox v-model="unternehmen.gesichtsmasken">Gesichtsmasken (Mund-Nase-Masken)</Checkbox>
           <Checkbox v-model="unternehmen.ostern">Ostergeschenke</Checkbox>-->
          <Checkbox v-model="unternehmen.muttertag">Muttertagsgeschenke</Checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">Angebote und Aktionen: </b-col>
        <b-col lg="8" md="12">
          <textarea v-model="unternehmen.aktionen"></textarea>
        </b-col>
      </b-row>

      <b-row>
        <b-col offset-md="0" offset-lg="4" cols-md="6" cols-lg="4" class="text-left">
          <button class="btn-all" @click="confirm(unternehmen.id)" v-if="unternehmen.id != todelete && !unternehmen.new">Filiale entfernen</button>
          <button class="btn-all red" @click="deleteConfirm(unternehmen.id)" v-if="unternehmen.id == todelete">Filiale wirklich entfernen?</button>
        </b-col>
        <b-col cols-md="6" cols-lg="4" class="text-right">
          <button class="btn-all" @click="saveUnternehmen">{{ unternehmen.new ? 'Anlegen' : 'Speichern' }}</button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-left">
          *) Pflichtfeld
        </b-col>
      </b-row>
    </b-container>

    <Footer />
  </div>
  <div class="profile" v-else>
    <Header />
    <div class="profil-header">
      <b-container>
        <b-row>
          <b-col>
            <h1>Fehler</h1>
            <p>Bitte loggen Sie sich ein.</p>
          </b-col>
        </b-row>
      </b-container>
      <Footer />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import DropDown from '@/components/FormInputs/DropDown.vue';
import Upload from '@/components/FormInputs/Upload.vue';
import Checkbox from '@/components/FormInputs/Checkbox.vue';
import Popup from '@/components/Base/Popup.vue';

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    DropDown,
    Upload,
    Popup,
    Checkbox,
  },
  data() {
    return {
      unternehmens: [],
      selected: 0,
      password1: '',
      password2: '',
      currentpassword: '',
      todelete: 0,
    };
  },
  mounted() {
    this.$store.dispatch('loadUnternehmenFromCurrentUser').then((results) => {
      this.unternehmens = results.data.message;
    });
  },
  methods: {
    deleteImage(name) {
      this.$store
        .dispatch('deleteImage', {
          userid: this.unternehmen['user_id'],
          id: this.unternehmen.id,
          name,
        })
        .then((result) => {
          this.$store.dispatch('addMessage', {
            message: 'Bild entfernt!',
            type: 'success',
          });
          this.unternehmens[this.selected][name] = false;
        });
    },
    confirm: function(id) {
      this.todelete = id;

      setTimeout(
        function() {
          this.todelete = 0;
        }.bind(this),
        2000
      );
    },
    deleteConfirm: function(id) {
      this.$store
        .dispatch('deleteUnternehmen', id)
        .then((results) => {
          this.$store.dispatch('addMessage', {
            message: 'Filiale gelöscht!',
            type: 'success',
          });
          this.$store.dispatch('loadUnternehmenFromCurrentUser').then((results) => {
            this.unternehmens = results.data.message;
          });
        })
        .catch((err) => {
          this.$store.dispatch('addMessage', {
            message: 'Beim Löschen ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
            type: 'error',
          });
        });
    },
    setPassword: function(value) {
      if (this.password1 != this.password2) {
        this.$store.dispatch('addMessage', {
          message: 'Die Passwörter müssen übereinstimmen!',
          type: 'error',
        });
      } else {
        this.$store
          .dispatch('savePassword', {
            current: this.currentpassword,
            newpw: this.password1,
          })
          .then((results) => {
            if (!results.data.message.success) {
              this.$store.dispatch('addMessage', {
                message: results.data.message.message,
                type: 'error',
              });
            } else {
              this.$store.dispatch('addMessage', {
                message: results.data.message.message,
                type: 'success',
              });
              this.password1 = '';
              this.password2 = '';
              this.currentpassword = '';
            }
          })
          .catch((err) => {
            this.$store.dispatch('addMessage', {
              message: 'Beim Speichern des Passwortes ist ein Fehler aufgetreten, bitte versuchen sie es später erneut.',
              type: 'error',
            });
          });
      }
    },
    saveUnternehmen: function() {
      if (
        this.unternehmen.firma != '' &&
        this.unternehmen.firma != null &&
        this.unternehmen.branche != 0 &&
        this.unternehmen.adresse != '' &&
        this.unternehmen.adresse != null &&
        this.unternehmen.nr != '' &&
        this.unternehmen.nr != null &&
        this.unternehmen.plz != '' &&
        this.unternehmen.plz != null &&
        this.unternehmen.ort != '' &&
        this.unternehmen.ort != null &&
        this.unternehmen.bundesland != 0 &&
        (this.unternehmen.bezirk != 0 || this.bezirke.length == 0)
      ) {
        if (this.unternehmen.new) {
          this.$store
            .dispatch('createUnternehmen', this.unternehmen)
            .then((results) => {
              this.$store.dispatch('addMessage', {
                message: 'Filiale angelegt!',
                type: 'success',
              });
              this.$store.dispatch('loadUnternehmenFromCurrentUser').then((results) => {
                this.unternehmens = results.data.message;
              });
            })
            .catch((err) => {
              this.$store.dispatch('addMessage', {
                message: 'Beim Speichern ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
                type: 'error',
              });
            });
        } else {
          this.$store
            .dispatch('saveUnternehmen', this.unternehmen)
            .then((results) => {
              this.$store.dispatch('addMessage', {
                message: 'Gespeichert!',
                type: 'success',
              });
            })
            .catch((err) => {
              this.$store.dispatch('addMessage', {
                message: 'Beim Speichern ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
                type: 'error',
              });
            });
        }
      } else {
        if (this.unternehmen.firma == '' || this.unternehmen.firma == null) {
          this.$store.dispatch('addMessage', {
            message: 'Der Name Ihres Betriebes darf nicht fehlen.',
            type: 'error',
          });
        }
        if (this.unternehmen.branche == 0) {
          this.$store.dispatch('addMessage', {
            message: 'Bitte wählen Sie eine Branche.',
            type: 'error',
          });
        }
        if (this.unternehmen.adresse == '' || this.unternehmen.adresse == null) {
          this.$store.dispatch('addMessage', {
            message: 'Die Straße Ihres Betriebes darf nicht fehlen.',
            type: 'error',
          });
        }
        if (this.unternehmen.nr == '' || this.unternehmen.nr == null) {
          this.$store.dispatch('addMessage', {
            message: 'Die Hausnummer Ihres Betriebes darf nicht fehlen.',
            type: 'error',
          });
        }
        if (this.unternehmen.plz == '' || this.unternehmen.plz == null) {
          this.$store.dispatch('addMessage', {
            message: 'Die Postleitzahl Ihres Betriebes darf nicht fehlen.',
            type: 'error',
          });
        }
        if (this.unternehmen.ort == '' || this.unternehmen.ort == null) {
          this.$store.dispatch('addMessage', {
            message: 'Der Ort Ihres Betriebes darf nicht fehlen.',
            type: 'error',
          });
        }

        if (this.unternehmen.bundesland == 0) {
          this.$store.dispatch('addMessage', {
            message: 'Bitte wählen Sie ein Bundesland.',
            type: 'error',
          });
        }
        if (this.unternehmen.bezirk == 0 && this.bezirke.length > 0) {
          this.$store.dispatch('addMessage', {
            message: 'Bitte wählen Sie einen Bezirk.',
            type: 'error',
          });
        }
      }
    },
    createUnternehmen: function() {
      this.unternehmens.push({
        new: true,
        branche: 0,
        bezirk: 0,
        bundesland: 0,
        adresse: '',
        nr: '',
        plz: '',
        ort: '',
        aktionen: '',
      });
      this.selected = this.unternehmens.length - 1;
    },
    setSelected: function(value) {
      this.selected = value;
    },
    imagepath: function(image) {
      return `${this.$store.state.imagedir}${image}`;
    },
    setBranche: function(value) {
      this.unternehmen.branche = value;
    },
    setBundesland: function(value) {
      this.unternehmen.bundesland = value;
      this.unternehmen.bezirk = 0;
    },
    setBezirk: function(value) {
      this.unternehmen.bezirk = value;
    },
    refreshLogoImage: function(success) {
      if (success.sucess) {
        this.unternehmen.logo = success.file + '?t=' + new Date().getTime();
      }
    },
    refreshHeaderImage: function(success) {
      if (success.sucess) {
        this.unternehmen.header = success.file + '?t=' + new Date().getTime();
      }
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
    unternehmen: function() {
      if (this.unternehmens.length > 0) {
        return this.unternehmens[this.selected];
      } else {
        return {};
      }
    },
    branchen: function() {
      return this.$store.getters.allBranchen;
    },
    bundeslaender: function() {
      return this.$store.getters.allBundeslaender;
    },
    bezirke: function() {
      return this.$store.getters.getBezirkeForBundesland(this.unternehmen.bundesland);
    },
    unternehmensOptions: function() {
      return this.unternehmens.map((item, index) => {
        if (!item.firma) {
          return {
            id: index,
            name: 'Neue Filiale - Bitte tragen Sie die Daten im Formular unten ein.',
          };
        } else {
          return {
            id: index,
            name: `${item.firma} - ${item.adresse || ''} ${item.nr || ''}, ${item.plz || ''} ${item.ort || ''}`,
          };
        }
      });
    },
  },
};
</script>
